import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { inputAlphaNumeric } from '../../helperFunctions/helperFunctions';

const AddGSTModal = ({
  openstatus,
  clickListen,
  title,
  defaultValue = { gst_flag: 'N', gst: '', newOpen: true },
}) => {
  const [radioValue, setRadioValue] = useState(defaultValue.gst_flag);
  const [gstValue, setGSTValue] = useState(defaultValue.gst);
  const [gstError, setGstError] = useState();

  useEffect(() => {
    setRadioValue(defaultValue.gst_flag);
    setGSTValue(defaultValue.gst);
    validateGST({ target: { value: gstValue } });
  }, [defaultValue]);

  const modalClick = (status) => {
    console.log(status);
    if (radioValue === 'Y') {
      let regex = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$';
      if (gstValue.match(regex) && gstValue !== '') {
        setGstError(false);

        clickListen(status, radioValue, gstValue);
      } else {
        setGstError(true);
      }
    } else {
      clickListen(status, radioValue, gstValue);
    }
  };

  const validateGST = (e) => {
    let txt = e.target.value;
    console.log(txt);
    txt = txt.toUpperCase();
    var regex =
      '^[0-9]{2}[A-Z]{5}[0-9]{4}' + '[A-Z]{1}[1-9A-Z]{1}' + 'Z[0-9A-Z]{1}$';
    console.log('testts');
    if (txt.length === 15) {
      if (!txt.match(regex)) {
        setGstError(true);
        e.preventDefault();
      } else {
        setGstError(false);
      }
    } else {
      setGstError(true);
    }
  };

  return (
    <>
      {openstatus && (
        <Dialog
          maxWidth='sm'
          open={openstatus}
          onClose={() => modalClick('close')}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle
            id='alert-dialog-title-referal'
            sm={{
              textAlign: 'center',
              fontSize: 'h5.fontSize',
              fontWeight: 'bold',
              textTransform: 'capitalize',
            }}
          >
            {title !== '' && (
              <p className='titlename' style={{ fontSize: 20 }}>
                {title}
              </p>
            )}

            <button
              type='button'
              className='btn-close btn-close-white'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={() => modalClick('close')}
            ></button>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <div>
                <p className='dematModalHeader'>Do you have a GST number?</p>
                <FormControl className='centerAlign'>
                  <RadioGroup
                    row
                    name='haveGST'
                    className='centerAlign'
                    onChange={(e, value) => {
                      setRadioValue(e.target.value);
                    }}
                    defaultValue={radioValue}
                  >
                    <FormControlLabel
                      value='Y'
                      checked={radioValue === 'Y'}
                      control={<Radio />}
                      label='Yes'
                    />
                    <FormControlLabel
                      value='N'
                      checked={radioValue === 'N'}
                      control={<Radio />}
                      label='No'
                    />
                  </RadioGroup>
                </FormControl>
                {radioValue === 'Y' && (
                  <div>
                    <div
                      className='form-floating make100'
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      <TextField
                        label='GST Number'
                        variant='outlined'
                        className={`PANtext ${gstError ? '' : 'PanVerified'}`}
                        type='text'
                        autoComplete='off'
                        name='GSTNumber'
                        defaultValue={gstValue}
                        onChange={(e) =>
                          inputAlphaNumeric(e, (value) => {
                            validateGST(e);
                            setGSTValue(value);
                          })
                        }
                        required
                        size='small'
                        style={{ minWidth: 250 }}
                        error={gstError === true}
                        inputProps={{ maxLength: 15 }}
                        helperText={
                          gstError === true && 'Please Enter GST Number'
                        }
                      />
                    </div>
                  </div>
                )}
                <div className='modalButtonContainer'>
                  <button
                    type='button'
                    name='button'
                    className='btncolor btncolorBlue small-btn'
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      minWidth: 120,
                    }}
                    onClick={() =>
                      modalClick(defaultValue.newOpen ? 'addGST' : 'editGST')
                    }
                  >
                    Save & Continue
                  </button>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default AddGSTModal;
